import { en } from './en.js';
const PLACEHOLDER = /\{([a-zA-Z0-9_]+)\}/g;
export function placeholders(message) {
    return [...message.matchAll(PLACEHOLDER)].map((m) => m[1] ?? '').sort();
}
/** Interpolate `{name}` placeholders. Missing params throw in dev/test so bugs surface early. */
export function format(message, params = {}) {
    return message.replace(PLACEHOLDER, (_, name) => {
        const v = params[name];
        if (v === undefined)
            throw new Error(`missing i18n param "${name}"`);
        return String(v);
    });
}
const catalogues = { en };
export function t(key, params, locale = 'en') {
    const cat = catalogues[locale] ?? en;
    return format(cat[key], params);
}
/** Every key present, non-empty, and with the same placeholders as English. */
export function checkCatalogue(candidate) {
    const problems = [];
    for (const key of Object.keys(en)) {
        const msg = candidate[key];
        if (!msg) {
            problems.push(`missing key "${key}"`);
            continue;
        }
        if (placeholders(msg).join() !== placeholders(en[key]).join())
            problems.push(`placeholder mismatch in "${key}"`);
    }
    return problems;
}
//# sourceMappingURL=format.js.map